<template>
  <section class="brand-catalogue">
    <div class="brand-catalogue-inner">
      <div class="catalogue-title">Available Brands</div>
      <div class="brand-grid">
        <button v-for="(brand, index) in allBrands" :key="index" :class="['brand-item', brand.active ? 'active' : '']"
          type="button" @click="selectBrand(index, brand)">
          {{ brand.name }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandCatalogue',
  data() {
    return {
      allBrands: [],
      loading: false
    }
  },
  mounted() {
    this.fetchBrands()
  },
  methods: {
    async fetchBrands() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Content/home',
          method: 'get',
          data:{
            is_recommend:1,
          }
        })
        const brands = (res && res.data && res.data.brands) || []
        this.allBrands = brands.map((brand) => ({
          id: brand.id,
          name: brand.name,
          active: false
        }))
        if (brands.length > 14) {
          this.allBrands.push({ name: 'VIEW MORE', active: false })
        }
      } catch (err) {
        console.error('Failed to fetch brands:', err)
      } finally {
        this.loading = false
      }
    },
    selectBrand(index, selectedBrand) {
      this.allBrands.forEach((brand, i) => {
        brand.active = i === index
      })
      if (selectedBrand.name === 'VIEW MORE') {
        this.$router.push({ name: 'catalogue' })
      } else if (selectedBrand.id) {
        this.$router.push({ name: 'catalogue', query: { brand_id: selectedBrand.id } })
      }
    }
  }
}
</script>

<style scoped>
.brand-catalogue {
  width: 100%;
  padding: 0 20px 38px;
  background-color: #fff;
}

.brand-catalogue-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.catalogue-title {
  height: 44px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  background: #f3f3f3;
  color: #333;
  font-size: 18px;
  font-weight: 700;
}

.brand-grid {
  min-height: 258px;
  padding: 28px 34px 34px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  column-gap: 44px;
  row-gap: 32px;
  border: 1px solid #dddddd;
  border-top: 0;
  background-color: #fff;
}

.brand-item {
  height: 84px;
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  color: #666;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  transition: color 0.2s, box-shadow 0.2s, background-color 0.2s;
}

.brand-item:hover,
.brand-item.active {
  background-color: #fff;
  color: #ff5a1f;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
}

@media (max-width: 992px) {
  .brand-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 640px) {
  .brand-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
    padding: 20px;
  }
}
</style>
